module.exports = __webpack_public_path__ + "img/ennetix-comp-table.2afcfb90.png";